// Environment-based configuration
// All values are injected via REACT_APP_* env vars at build time.
// Only safe local-dev defaults are used as fallbacks — no production secrets or URLs in code.
const IS_PROD = process.env.REACT_APP_ENV === 'production';

export const BASE_URL = process.env.REACT_APP_SCORM_API_URL || 'http://localhost:5000';

// LRS Configuration — keys MUST come from env vars, no hardcoded secrets
export const LRS_ENDPOINT = process.env.REACT_APP_LRS_ENDPOINT || 'http://localhost:8080/xapi/';
export const LRS_API_KEY = process.env.REACT_APP_LRS_API_KEY || '';
export const LRS_API_KEY_SECRETE = process.env.REACT_APP_LRS_API_SECRET || '';

// SCORM content server
const SCORM_CONTENT_SERVER = process.env.REACT_APP_SCORM_CONTENT_SERVER || 'http://localhost:3000';

// SCORM viewer URL (used as lmsHomePage for xAPI)
export const SCORM_VIEWER_URL = process.env.REACT_APP_SCORM_VIEWER_URL || 'http://localhost:3000';

// Backend API URL (used for course progress callbacks)
export const BACKEND_API_URL = process.env.REACT_APP_BACKEND_API_URL || 'http://localhost:8055/api';

// Web app URL (used for redirect after course completion)
export const WEB_URL = process.env.REACT_APP_WEB_URL || 'http://localhost:5173';

export function GetCoursesBaseUrl() {
    if (window.location.origin.startsWith('http://localhost')) {
        return `${window.location.origin}/cloudfront/public`;
    }
    if (IS_PROD) {
        return `${SCORM_CONTENT_SERVER}/public`;
    }
    const endpoint = window.location.origin;
    return `${endpoint}/public`;
}

export function GetScormCoursesBaseUrl() {
    // In development, use the proxy
    if (window.location.origin.startsWith('http://localhost')) {
        const endpoint = `${window.location.origin}/cloudfront`;
        return `${endpoint}/scorm-contents`;
    }

    if (IS_PROD) {
        return `${SCORM_CONTENT_SERVER}/scorm-contents`;
    }

    return `${SCORM_CONTENT_SERVER}/scorm-contents`;
}